const theme = {
    color: {
        background: '#F5F5F5',
        gray: '#F5F5F5',
        primary: '#0077FF',
    },
    padding: {
        standard: '4px',
        card: '12px',
        large: '8px',
        top: '24px',
    },
    margin: {
        standard: '4px',
        large: '8px',
        top: '16px',
    },
    border: {
        standard: {
            color: '#0000001A',
            radius: '5px',
            size: `1px`,
        },
    },
    boxShadow: {
        card: `0px 1px 4px rgba(0, 0, 0, 0.16);`,
    },
    fontFamily: 'Open Sans, sans-serif',
    font: {
        header: '23px',
        pageTitle: '18px',
        title: '18px',
        large: '14px',
        normal: '12px',
        small: '10px',
        little: '8px',
        metricsValue: '35px',
        metricsSubValue: '15px',
    },
};

export default theme;
